import Image from "next/image";
import { useRouter } from "next/router";
import React, { FC, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { isMobile } from "react-device-detect";
import { CircularProgress } from "@mui/material";
import { loginUser } from "../../../services/auth";
import { notify } from "../../notify/alertMessage";

interface HeroSectionProps {}

const HeroSection: FC<HeroSectionProps> = () => {
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .max(60, "Must 60 characters or less")
        .email("Please enter a valid email")
        .required("Please enter your email"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);

      try {
        const response = await loginUser(values.email, "password");
        console.log("response", response);
      } catch (error: any) {
        console.log("error", error?.response?.data?.message);
        if (error?.response?.data?.message == "User not found") {
          router.push({
            pathname: "/auth/get-started",
            search: `?email=${values.email}`,
          });
        } else if (error?.response?.data?.message == "Password was incorrect") {
          router.push({
            pathname: "/auth/login",
            search: `?email=${values.email}`,
          });
        } else {
          notify("An error occured", "error");
        }
      }
    },
  });
  const router = useRouter();
  return (
    <div>
      <div className="mx-4 sm:mx-16 xl:mx-40 2xl:mx-96 pb-16 lg:py-16  ">
        <div className="flex flex-col-reverse lg:flex-row lg:mb-24">
          <div className="lg:w-1/2 ">
            <div className=" lg:w-11/12 xl:w-10/12 2xl:w-11/12 text-center lg:text-left -mt-16 lg:-mt-0">
              <div className="w-11/12  mx-auto lg:ml-0 ">
                <p className="text-2xl  sm:text-4xl  2xl:text-5xl font-semibold future-letter-spacing2 future-text-black leading-snug xl:future-line-height mt-12">
                  Earn more when the price of Bitcoin is rising. Or falling.
                </p>
                <p className="text-lg sm:text-2xl tracking-wide font-thin future-text-gray mt-4 sm:mt-8 leading-snug future-letter-spacing3 sm:future-letter-spacing2">
                  The price of Bitcoin moves up &amp; down, constantly changing.
                  GetFuture enables you invest in the direction of bitcoin to
                  earn more.
                </p>
              </div>

              <form
                className="mt-8 flex text-sm sm:text-base"
                onSubmit={formik.handleSubmit}
              >
                <input
                  className="custom-input-green custom-border-radius h-12 w-full px-4 font-normal outline-none"
                  placeholder="Enter Your Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="email"
                />
                <button
                  // onClick={() => router.push("/auth/get-started")}
                  type="submit"
                  className="bg-green-dark h-12 w-56 custom-border-radius outline-none ml-2 sm:ml-4 flex items-center justify-center"
                >
                  Get Started
                  {isLoading && (
                    <CircularProgress
                      color="inherit"
                      style={{ marginLeft: "1rem" }}
                      size={20}
                    />
                  )}
                </button>
              </form>
              <div>
                {formik.touched.email && formik.errors.email && (
                  <p className="custom-text-pink text-left future-letter-spacing3 text-sm mt-2">
                    {formik.errors.email}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className=" lg:w-1/2 ">
            <div className="flex justify-end w-full ">
              <div className="relative overflow-y-hidden h-56 w-56 sm:h-[30rem] sm:w-[30rem] -mt-10">
                <Image
                  src="/illustrations/test.svg"
                  layout="fill"
                  className=""
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
